import { createTypedEnum } from '@reckon-web/formschema-enums';

export const RecurrenceFrequencyEnum = createTypedEnum({
  OneMonth: 'OneMonth',
  TwoMonths: 'TwoMonths',
  ThreeMonths: 'ThreeMonths',
  SixMonths: 'SixMonths',
  TwelveMonths: 'TwelveMonths',
  SevenDays: 'SevenDays',
  FourteenDays: 'FourteenDays',
} as const);
export type RecurrenceFrequencyEnumValue =
  (typeof RecurrenceFrequencyEnum.values)[number];
export type RecurrenceFrequencyEnumLabel =
  (typeof RecurrenceFrequencyEnum.labels)[number];
